/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Businessaddress1Inputs */

const de__field_businessaddress1 = /** @type {(inputs: _Field_Businessaddress1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dienstadresse`)
};

/**

* @param {_Field_Businessaddress1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_businessaddress1 = /** @type {((inputs?: _Field_Businessaddress1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Businessaddress1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_businessaddress1(inputs)
});
export { _field_businessaddress1 as "_field_businessAddress" }